<template>
  <div class="l-row">
    <div class="margin" :class="size">
      <strong class="ds-block">{{ $t('price.type.label') }}</strong>
      {{ $t(`${price.type}.label`) }}
    </div>

    <div class="margin" v-if="price.auxiliary !== 0" :class="size">
      <strong class="ds-block">{{ $t(`price.${price.type}.auxiliary.label`) }}</strong>
      <span v-if="price.type === 'fixedValue'">{{ price.auxiliary | currency }}</span>
      <span v-else>{{ `${price.auxiliary} %` }}</span>
    </div>

    <div class="margin" :class="size">
      <strong class="ds-block">{{ $t('price.previous.label') }}</strong>
      {{ price.previous | currency }}
    </div>

    <div :class="size">
      <strong class="ds-block">{{ $t('price.current.label') }}</strong>
      {{ price.current | currency }}
    </div>
  </div>
</template>

<script>
  export default {
    props: {
      price: {
        type: Object,
        required: true
      },
      columnSize: {
        type: String,
        default: '12'
      }
    },
    computed: {
      size () {
        return `l-col-${this.columnSize}@md`
      }
    }
  }
</script>

<style lang="sass" scoped>
  .margin
    margin-bottom: 15px
</style>



// WEBPACK FOOTER //
// Price.vue?41dddcbc